import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

import { useUsersStore } from '../model/store'

/**
 * `DELETE /admin-api/users/{user}` — remove a user (and detach its team links).
 */
export const useUserDelete = async (userId: string | number): Promise<boolean> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()
  const store = useUsersStore()

  const url = useAdminRoutes('admin.users.delete', { user_id: userId })

  store.setSaving(true)

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return false
    }

    const { data } = await $axios.delete<ApiResponse>(url)

    if (!data.success) {
      toast.error(data.message)
      return false
    }

    toast.success(data.message)

    return true
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))
    return false
  } finally {
    store.setSaving(false)
  }
}
